import {
  Partners,
  QUOTE_TYPES,
  QUOTE_WORKFLOW_STATUSES,
  QuoteType,
  QuoteWorkflowStatus,
} from '@lockton-apps/shared/interfaces';
import { createDefinition } from '@lockton-apps/shared/util/helpers';
import {
  StatusQueueConfigOverride,
  WorkflowStatusQueueMeta,
} from './interface';

export const getStatusQueueWorkflowMetaDef =
  createDefinition<WorkflowStatusQueueMeta>({
    base: {
      next: null,
      upcoming: [],
    },
    variants: {
      [QUOTE_WORKFLOW_STATUSES.NewProposal]: {
        base: {},
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]: {
                base: {
                  next: QUOTE_WORKFLOW_STATUSES.ProposalSent,
                  upcoming: [],
                },
              },
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.ProposalSent]: {
        base: {},
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]: {
                base: {
                  next: QUOTE_WORKFLOW_STATUSES.ProposalComplete,
                  upcoming: [],
                },
              },
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.ProposalComplete]: {
        base: {},
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]: {
                base: {
                  next: QUOTE_WORKFLOW_STATUSES.QuoteRequested,
                  upcoming: [],
                },
              },
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteRequested]: {
        base: {},
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]: {
                base: {
                  next: QUOTE_WORKFLOW_STATUSES.QuoteReady,
                  upcoming: [],
                },
              },
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteReady]: {
        base: {},
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]: {
                base: {
                  next: QUOTE_WORKFLOW_STATUSES.QuoteSent,
                  upcoming: [],
                },
              },
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteSent]: {
        base: {
          next: QUOTE_WORKFLOW_STATUSES.QuoteAccepted,
          upcoming: [QUOTE_WORKFLOW_STATUSES.AwaitingPayment],
        },
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]: {
                base: {
                  next: QUOTE_WORKFLOW_STATUSES.QuoteAccepted,
                  upcoming: [],
                },
              },
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteAccepted]: {
        base: {
          next: QUOTE_WORKFLOW_STATUSES.AwaitingPayment,
          upcoming: [],
        },
      },
      [QUOTE_WORKFLOW_STATUSES.AwaitingPayment]: {
        base: {},
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]: {
                base: {
                  next: QUOTE_WORKFLOW_STATUSES.PolicyDocumentationSent,
                  upcoming: [],
                },
              },
            },
          },
        },
      },
    },
  });

export const statusQueueStatusOverrides: Partial<
  Record<Partners | 'DEFAULT', StatusQueueConfigOverride>
> = {
  DEFAULT: {},
};

export function getStatusQueueMeta(
  status: QuoteWorkflowStatus,
  quoteType: QuoteType,
  partner: Partners | 'DEFAULT' = 'DEFAULT'
) {
  return getStatusQueueWorkflowMetaDef([status, quoteType, partner]);
}
